import React, { useState } from "react";
import "./SignupForm.css";
import Dots from "../../../../assets/images/about-shape3.png";
import Triangle1 from "../../../../assets/images/signuptri1.png";
import Triangle2 from "../../../../assets/images/signuptri2.png";
import CustomDropdown from "../../../../Components/CustomDropdown/CustomDropdown";
import EyeClose from "../../../../assets/images/eye-close.png";
import { Link } from "react-router-dom";
const SignupForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="signup__form_section">
      <img src={Dots} alt="" className="signup__form_dots" />
      <div className="signup__formwrap">
        <img src={Triangle1} alt="" className="signup__formtriangle1" />
        <img src={Triangle2} alt="" className="signup__formtriangle2" />
        <div className="signup__form">
          <div className="signup__form_heading">Sign Up</div>
          <form className="signup__formcontent">
            <div className="signup__formrow">
              <div className="signup__formcolleft">
                <label className="signup__formlabel">Name</label>
                <input
                  className="signup__formfield"
                  type="text"
                  placeholder="Your Full Name"
                />
              </div>
              <div className="signup__formcol">
                <label className="signup__formlabel">Phone Number</label>
                <input
                  className="signup__formfield"
                  type="text"
                  placeholder="Enter Your Number"
                />
              </div>
            </div>
            <div className="signup__formrow">
              <div className="signup__formcolleft">
                <label className="signup__formlabel">Email</label>
                <input
                  className="signup__formfield"
                  type="Email"
                  placeholder="Enter Your Email"
                />
              </div>
              <div className="signup__formcol">
                <label className="signup__formlabel">Confirm Email</label>
                <input
                  className="signup__formfield"
                  type="Email"
                  placeholder="Enter Your Email"
                />
              </div>
            </div>
            <div className="signup__formrow">
              <div className="signup__formcolleft">
                <label className="signup__formlabel">Password</label>
                <div className="signup__passwordfield_wrap">
                  <input
                    className="signup__formfield"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Your Password"
                  />
                  <img
                    src={EyeClose}
                    alt=""
                    className="signup__passwordfield_eyeicn"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
              </div>
              <div className="signup__formcol">
                <label className="signup__formlabel">Repeat Password</label>
                <div className="signup__passwordfield_wrap">
                  <input
                    className="signup__formfield"
                    type={showPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                  />
                  <img
                    src={EyeClose}
                    alt=""
                    className="signup__passwordfield_eyeicn"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
              </div>
            </div>
            <div className="signup__formrow">
              <div className="signup__formcolleft">
                <label className="signup__formlabel">Year of tax filing</label>
                <CustomDropdown
                  options={["2000", "2001", "2002", "2003", "2004"]}
                />
              </div>
              <div className="signup__formcol">
                <label className="signup__formlabel">
                  How do you know about Serene Tax Filer?
                </label>
                <CustomDropdown options={["Linkedin", "Facebook", "Google"]} />
              </div>
            </div>
            <div className="signup__formrow">
              <div className="signup__formcolleft">
                <label className="signup__formlabel">Prefered Time Zone</label>
                <CustomDropdown options={["GST", "IST", "PST"]} />
              </div>
              <div className="signup__formcol"></div>
            </div>
            <div className="signup__formrow">
              <button className="signup__formsubmit_btn">Create Account</button>
            </div>
            <div className="signup__formrow">
              <div className="signup__formsubmit_link">
                Have an account? <Link to="/login">Sign In</Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
